module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-35.f712b4e3.png";